<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    class="h-5 w-5"
    :class="customStyle"
  >
    <path
      fill-rule="evenodd"
      d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowUpIcon',

  props: {
    customStyle: {
      type: String,
      default: 'w-6 h-6',
    },
  },
}
</script>
